function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.128 1c.298 0 .539.241.539.538v.898h4.666v-.898a.538.538 0 011.077 0v.898h1.616c1.09 0 1.974.884 1.974 1.974v8.616c0 1.09-.884 1.974-1.974 1.974H2.974A1.974 1.974 0 011 13.026V4.41c0-1.09.884-1.974 1.974-1.974H4.59v-.898c0-.297.24-.538.538-.538zM4.59 3.513H2.974a.897.897 0 00-.897.897v8.616c0 .495.402.897.897.897h10.052a.897.897 0 00.897-.897V4.41a.897.897 0 00-.897-.897H11.41v.897a.538.538 0 01-1.077 0v-.897H5.667v.897a.538.538 0 01-1.077 0v-.897zm-.718 3.769c0-.297.24-.538.538-.538h7.18a.538.538 0 110 1.077H4.41a.538.538 0 01-.538-.539z",
  fill: "#2D2D2D"
});
function SvgCalendario(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default __webpack_public_path__ + "/img/Calendario.svg";
export { SvgCalendario as ReactComponent };